module.exports = __webpack_public_path__ + "static/media/banner-2-JP-1.7f162722.jpg";